module.exports = __webpack_public_path__ + "img/m_hydol_top.72d469b1.png";